import { render, staticRenderFns } from "./CalculatorBlock.vue?vue&type=template&id=315eae19&scoped=true&"
import script from "./CalculatorBlock.vue?vue&type=script&lang=js&"
export * from "./CalculatorBlock.vue?vue&type=script&lang=js&"
import style0 from "./CalculatorBlock.vue?vue&type=style&index=0&id=315eae19&prod&lang=scss&scoped=true&"
import style1 from "./CalculatorBlock.vue?vue&type=style&index=1&id=315eae19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315eae19",
  null
  
)

export default component.exports